import styled from 'styled-components';
import MuiAlert from "@material-ui/lab/Alert";

export const StyledMuiAlert = styled(MuiAlert)`
    background: #fff;
    border: 1px solid #E1E9FA;
    border-radius: 8px;

    .MuiAlert-icon {
      display: flex;
      align-items: center;

      svg {
        color: #CFD6E5;
      }
    }

    .MuiAlert-message {
      color: #17181A;

      .MuiAlertTitle-root {
        color: #26427C;
      }
    }

    .MuiAlert-action {}
`;
